export default "__VITE_ASSET__4857db7b__"